import COMPANY_API from '@/api/dataBase';
export const searchFormColumns = (ctx) => {
  return [
    {
      name: '监管单号',
      prop: 'billNo',
      type: 'input',
    },
    {
      name: '监管单状态',
      prop: 'billStatus',
      type: 'select',
      options: ctx.supervisionBillStatusList,
    },
    // {
    //   name: '仓库公司',
    //   prop: 'storageCompanyName',
    //   type: 'searchTableSpec',
    //   searchType: 'warehouseCompany',
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    // },
    {
      prop: 'storageCompanyName',
      name: '仓库公司',
      type: 'ajaxSelect',
      apiUrl: COMPANY_API.GET_PERSON_API,
      apiData: {
        id: ctx.userInfo.userInfo.userCode,
        userCode: ctx.userInfo.userInfo.userCode,
        personName: ctx.userInfo.userInfo.userName,
      },
      dataString: 'data.personCompanyInfo',
      clearable: true,
      filterable: true,
      valueKey: 'personCompanyName',
      labelKey: 'personCompanyName',
      changeMethod: 'changeMethod',
      method: 'post',
    },
    {
      name: '仓库名称',
      prop: 'storageName',
      type: 'searchTableSpec',
      searchType: 'warehouse',
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '监管合同号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '创建日期',
      prop: 'billCreateDate',
      type: 'date',
    },
  ];
};

export const baseColumnListDefault = [
  {
    field: 'billNo',
    title: '监管单号',
  },
  {
    field: 'contractNo',
    title: '合同号',
  },
  {
    field: 'billStatus',
    title: '监管单状态',
  },
  {
    field: 'billCreateDate',
    title: '创建日期',
  },
  {
    field: 'storageCompanyName',
    title: '仓库公司',
  },
  {
    field: 'storageName',
    title: '仓库名称',
  },
  {
    field: 'stockQuantity',
    title: '库存数量/重量',
  },
  {
    field: 'inStockQuantity',
    title: '入库数量/重量',
  },
  {
    field: 'outStockQuantity',
    title: '出库数量/重量',
  },
  {
    field: 'stockValue',
    title: '在库价值',
  },
  {
    field: 'remark',
    title: '备注',
  },
];

export const searchFormColumns1 = (ctx) => {
  return [
    {
      name: '监管单号',
      prop: 'billNo',
      type: 'input',
    },
    {
      name: '监管单状态',
      prop: 'billStatus',
      type: 'select',
      options: ctx.supervisionBillStatusList,
    },
    {
      name: '监管合同号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '单据创建日期',
      prop: 'billCreateDate',
      type: 'date',
    },
  ];
};

export const baseColumnListDefault1 = [
  {
    field: 'billNo',
    title: '监管单号',
  },
  {
    field: 'contractNo',
    title: '合同号',
  },
  {
    field: 'billStatus',
    title: '监管单状态',
  },
  {
    field: 'pledgeeName',
    title: '质权方',
  },
  {
    field: 'pledgorName',
    title: '出质方',
  },
  {
    field: 'stockQuantity',
    title: '库存数量/重量',
  },
  {
    field: 'inStockQuantity',
    title: '入库数量/重量',
  },
  {
    field: 'outStockQuantity',
    title: '出库数量/重量',
  },
  {
    field: 'stockValue',
    title: '在库价值',
  },
  {
    field: 'remark',
    title: '备注',
  },
];
